export function calculateEducationFees(
  annualCostOfEducationsFees,
  otherAssociatedCosts,
  amountOfSavingsToDate,
  growthAmount,
  yearWhenFutureEducationBegins,
  numberOfYearsInFutureEducation,
  currency){
  const goalcurYear = (new Date).getFullYear();
  const term = (yearWhenFutureEducationBegins - goalcurYear) * 12;

  const totalAnnualCost = parseInt(annualCostOfEducationsFees) + parseInt(otherAssociatedCosts);
  const i = growthAmount / 100;
  let savings = amountOfSavingsToDate * (Math.pow((1 + i), (term / 12)));
  savings = savings.toFixed(0);

  const total = (parseInt(annualCostOfEducationsFees,) + parseInt(otherAssociatedCosts)) * numberOfYearsInFutureEducation;
  const TotalAnnualCost = parseInt(annualCostOfEducationsFees) + parseInt(otherAssociatedCosts);

  const Goal = (TotalAnnualCost * numberOfYearsInFutureEducation) - amountOfSavingsToDate;
  const j = Math.pow((1 + i), (1 / 12)) - 1;
  const Sum = ((Math.pow((1 + j), term) - 1) / j) * (1 + j);
  let Answer = Goal / Sum;
  Answer = Answer.toFixed(2);

  const data = {
    "Total Costs per year": currency+ totalAnnualCost,
    "Money Saved + Growth": currency + savings,
    "Years Remaining": term / 12,
    "Annual Growth Rate": growthAmount,
    "Year Education Begins": yearWhenFutureEducationBegins,
    "Duration of Education": numberOfYearsInFutureEducation,
    "Total cost of further education": currency + total,
    "Monthly savings amount required": currency + Answer,
  }
  return data;
}
